import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toast";
import { AlertsPanel } from "../components/AlertsPanel";
import { UserPanel } from "../components/UserPanel";
import Navbar from "../components/Navbar";
import { Topmenu } from "../components/Topmenu";
import { useCliftContext } from "../hooks/useCliftContext";
import { CliftReducerAction } from "../context/clift-context/clift-action-types";

export const Layout = () => {
  const { currentUser, cliftState, dispatchCliftState } = useCliftContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.clientPrincipal) {
      navigate("/login");
    }

    if (currentUser?.clientPrincipal?.userRoles?.includes("authenticated")) {
      dispatchCliftState({
        type: CliftReducerAction.FetchTenants,
      });
    }
  }, [cliftState.currentTenant, currentUser?.clientPrincipal?.userRoles]);

  useEffect(() => {
    cliftState.sidepanelContent
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [cliftState.sidepanelContent]);

  return (
    <>
      <div
        id="app-container"
        className={cliftState.sidepanelContent ? "sidepanelopen" : ""}
        //https://stackoverflow.com/a/77153892
        {...{ inert: cliftState.sidepanelContent ? "" : undefined }}
      >
        <Navbar />
        <div
          style={{
            flexGrow: 1,
          }}
        >
          <Topmenu />
          <AlertsPanel />
          <UserPanel />
          <div className="app-container-content">
            <Outlet />
            <ToastContainer position="bottom-center" delay={5000} />
          </div>
        </div>
      </div>
      {cliftState.sidepanelContent ? cliftState.sidepanelContent : null}
    </>
  );
};
